'use client';
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import cx from 'classnames';
import styles from './AssociatedDealerDropdown.module.scss';
import { CatDropdown } from '@blocks-react/components/Dropdown';
import { CatList } from '@blocks-react/components/List';
import { CatListItem } from '@blocks-react/components/ListItem';
import { useDropdownController } from '../../../../hooks/form-controllers/useDropdownController';
import { Conditional, Drawer, DrawerBody, DrawerHeader } from '../../../common';
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { ReadonlyValue } from '../read-only-value';
import { CatHeading } from '@blocks-react/components/Heading';
export const AssociatedDealerDropdown = ({ name, requiredNotation, optionalNotation, label, placeholder, itemList, item, required = false, disabled = false, readOnly = false, loading = false, isPCCAssociatedDealerFFEnabledAndMobile = false, showDropdown = true, isHeadless = false, selectedValue, status, errorNote, onSelect, position = 'auto', isPCCAssociatedDealerFFEnabled = false, isMobile = false, isModal }) => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const { setValue, resetField } = useFormContext();
    const { dropdownField } = useDropdownController({ name }, onSelect);
    const firstItem = itemList?.[0];
    const defaultItem = itemList?.find((item) => item?.default);
    const isSingleItem = itemList?.length === 1;
    const showItemList = itemList?.length > 1;
    const selectedItem = itemList?.find((item) => item.value === selectedValue);
    /**
     * Sets the value of the field on first render and whenever itemList changes,
     * if an item is provided, we set that item as the value,
     * if there's only 1 item on the itemList, we set that item as the value,
     * if there's multiple values, we set the item that has default === true
     */
    useEffect(() => {
        if (item) {
            setValue(name, item.label);
        }
        else if (isSingleItem && firstItem) {
            setValue(name, firstItem.label);
        }
        else if (selectedItem) {
            setValue(name, selectedItem.label);
        }
        else if (defaultItem) {
            setValue(name, defaultItem.label);
        }
        else {
            resetField(name);
        }
        return () => {
            resetField(name);
        };
    }, [item, itemList]);
    const handleOpenMobileDrawer = () => {
        if (isMobile && isPCCAssociatedDealerFFEnabled) {
            setIsDrawerOpen(true);
        }
    };
    const handleCloseMobileDrawer = (e) => {
        e.stopPropagation();
        setIsDrawerOpen(false);
    };
    return (_jsxs(_Fragment, { children: [_jsx(Conditional, { test: isPCCAssociatedDealerFFEnabledAndMobile, children: _jsx("div", { className: cx(styles['text-font'], 'd-flex gap-4 justify-content-between align-items-center', { 'mb-3': isHeadless }), children: _jsx(CatHeading, { variant: "title-sm", className: cx({
                            [styles['associated-dealer-heading']]: isPCCAssociatedDealerFFEnabledAndMobile
                        }), children: dropdownField.value }) }) }), _jsxs(Conditional, { test: !readOnly && showDropdown, children: [_createElement(CatDropdown, { ...dropdownField, notation: required ? requiredNotation : optionalNotation, onClick: handleOpenMobileDrawer, fieldId: name, name: name, label: label, title: label, placeholder: placeholder, required: required, disabled: disabled, isReadonly: readOnly, ...(isPCCAssociatedDealerFFEnabled &&
                            isMobile && { isActive: false }), isLoading: loading, "data-testid": `${name}-test`, className: cx('data-cs-mask', {
                            [styles['associated-dealer-drawer-dropdown-mobile']]: isPCCAssociatedDealerFFEnabled && isMobile
                        }), key: `adp-${name}-${dropdownField.value}`, position: position, isInline: false, status: status, errorNote: errorNote },
                        _jsx(Conditional, { test: showItemList, children: _jsx(CatList, { children: itemList?.map((item) => (_jsx(CatListItem, { value: item?.label, children: item?.label }, `${name}-option-${item?.value}`))) }) })), _jsx(Conditional, { test: showItemList &&
                            isMobile &&
                            isPCCAssociatedDealerFFEnabled &&
                            !isModal, children: _jsxs(Drawer, { orientation: "bottom", isActive: isDrawerOpen, onBlDrawerClose: handleCloseMobileDrawer, hasBackdrop: false, children: [_jsx(DrawerHeader, { children: _jsx(CatHeading, { variant: "title-sm", children: label }) }), _jsx(DrawerBody, { children: _jsx(CatList, { children: itemList?.map((item) => (_jsx(CatListItem, { onClick: (e) => {
                                                e.preventDefault();
                                                setValue(name, item.label);
                                                setIsDrawerOpen(false);
                                            }, value: item?.label, className: "py-2", children: item?.label }, `${name}-option-${item?.value}`))) }) })] }) })] }), _jsx(Conditional, { test: readOnly, children: _jsx(ReadonlyValue, { label: label, required: required, value: dropdownField.value, notation: required ? ` ${requiredNotation}` : ` ${optionalNotation}` }) })] }));
};
